<template>
  <v-toolbar class="ml-4 wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Charters</v-toolbar-title
    >

    <CreateCharter v-if="isQA" @charter-criado="fetchCharters" />
  </v-toolbar>
  <div class="ml-8" v-if="isQA">
    <v-checkbox
      v-model="isMyCharter"
      :label="`Meus charters`"
      color="primary"
      hide-details
    ></v-checkbox>
  </div>
  <v-table
    class="ma-8 mt-1 usecase--table elevation-1"
    style="background: transparent"
    fixed-header="true"
    density="comfortable"
  >
    <thead class="text-grey">
      <tr>
        <th class="rounded-ts-lg text-center text-grey">Charter</th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Objetivo
        </th>

        <th style="border-left: thin solid #efefef" class="text-Left text-grey">
          Status
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Ações
        </th>
      </tr>
    </thead>
    <div class="split"></div>

    <tbody>
      <tr v-for="item in listCharter(charters)" :key="item.id_charter">
        <td style="border-left: thin solid #efefef" class="text-center wdt">
          <RouterLink
            :to="'/projects/' + idProjeto + '/Charters/' + item.id_charter"
          >
            <p class="text-decoration-underline">
              {{ item.identificacao }}
            </p>
          </RouterLink>
        </td>
        <td class="text-left" style="border-left: thin solid #efefef">
          {{ item.objetivo }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-left">
          {{ formatarString(item.status_charter) }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          <v-row class="align-center">
            <v-col cols="1">
              <RouterLink
                :to="'/projects/' + idProjeto + '/Charters/' + item.id_charter"
              >
                <v-icon
                  size="large"
                  color="green-darken-2"
                  icon="mdi-eye-arrow-right-outline"
                ></v-icon>
              </RouterLink>
            </v-col>

            <v-col cols="1">
              <EditCharter
                v-if="isQA"
                @charter-editado="() => fetchCharters(this.idProjeto)"
                :id="item.id_charter"
                :charter="item"
                text=""
                color="green-darken-2"
                class="ml-2 ml-lg-n2"
              />
            </v-col>
          </v-row>
        </td>
      </tr>
    </tbody>
  </v-table>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script>
/**
 * @module CharterList
 * @desc Lista os charters.
 * @vue-data {number} [idProjeto=null] - O ID do projeto.
 * @vue-data {boolean} [dialog=false] - Ativador para abrir o modal de
 * criar charter.
 * @vue-data {boolean} [isLoading=false] - Loader da tela.
 * @vue-data {Array} [charters=[]] - Lista de charters.
 * @vue-data {String} [projeto=''] - Nome do projeto.
 * @vue-computed {Boolean} isQA - Flag que indica se o usuário
 * atual é testador no projeto
 */
import axios from 'axios';

import CreateCharter from '@/components/dialogs/CreateCharter.vue';
import EditCharter from '@/components/dialogs/EditCharter.vue';
import store from '@/store/store';
export default {
  name: 'CharterList',
  components: { CreateCharter, EditCharter },
  data: () => ({
    dialog: false,
    charters: [],
    isMyCharter: false,
    idProjeto: null,
    projeto: '',
    isLoading: false,
  }),
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.fetchCharters(this.idProjeto);
  },

  computed: {
    isQA() {
      return localStorage.getItem('formaAtuacao') === '"TESTADOR"';
    },
    myUserId() {
      return localStorage.getItem('idUsuario');
    },
  },
  methods: {
    /**
     * Formata uma string contendo palavras separadas por underscore (_)
     * para uma string em que as palavras começam com letra maiúscula
     * e o restante das letras são minúsculas e as
     * palavras são separadas por espaço
     *
     * @param {string} string - A string a ser formatada
     * @returns {string} A string formatada
     */
    formatarString(string) {
      const palavras = string.split('_');
      const iniciaisMaiusculas = palavras
        .map(
          (palavra) =>
            palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase(),
        )
        .join(' ');

      return iniciaisMaiusculas;
    },
    /**
     * Busca os chartes por ID do projeto
     *
     * @param {Number} idProjeto O id do projeto.
     */
    async fetchCharters(idProjeto) {
      this.isLoading = true;
      const apiUrl = process.env.VUE_APP_API_URL;
      const result = await axios.get(
        `${apiUrl}/api/v1/charters/projeto/${idProjeto}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        },
      );
      this.charters = result.data.charters;
      this.isLoading = false;
    },
    listCharter(charters) {
      // console.log(
      //   // eslint-disable-next-line arrow-body-style
      //   charters.map((item) => {
      //     return {
      //       id: item.id_usuario,
      //       ident: item.identificacao,
      //     };
      //   })
      // );
      // console.log(this.myUserId, 'MyUserId');
      if (this.isMyCharter) {
        return charters.filter((charter) => {
          console.log(
            `id_usuario: ${charter.id_usuario}, identificacao: ${
              charter.identificacao
            }, userId: ${this.myUserId}, isEqual: ${
              parseInt(charter.id_usuario) === parseInt(this.myUserId)
            }`,
          );

          return parseInt(charter.id_usuario) === parseInt(this.myUserId);
        });
      }

      return charters;
    },
  },
};
</script>
<style scoped>
.load {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.w-15 {
  width: 15px;
}

.wdt {
  width: 100px;
}

.limit {
  width: calc(100% - 50px);
}
</style>
